import React from 'react';
import getContent from '../lib/dictionaryFetcher';

const ConnectIneligible = () => {
  const backgroundImageUrl =
    'https://www.paypalobjects.com/web/res/f73/21d45b1a46be795d47747019bb39a/images/icons_2x.png';
  const imageStyle = { backgroundImage: `url('${backgroundImageUrl}')` };

  const onClickHandler = () => {
    if (typeof window !== 'undefined') {
      window.location.assign('/');
    }
  };

  return (
    <div className="connect">
      <div className="main scrollableWindow" id="main">
        <section className="connectSection">
          <div className="corral">
            <div
              id="content"
              className="contentContainer contentContainerBordered"
            >
              <div className="img-connect_notEligible" style={imageStyle} />
              <h1 className="headerText">
                {getContent('merchanthub', 'otss.walmart.headerText')}
              </h1>
              <p className="notEligibleText">
                {getContent('merchanthub', 'otss.walmart.notEligibleText')}
              </p>
              <div className="actions">
                <button
                  type="submit"
                  id="not_eligible_btn"
                  name="not_eligible_btn"
                  pa-marked="1"
                  onClick={onClickHandler}
                >
                  {getContent('merchanthub', 'otss.walmart.buttonText')}
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ConnectIneligible;
